/* Note:
- If it's themable using native component paramter, we use this space to make those definitions.
- If there isn't a native component paramter we can control, we use className to externalize the style
*/

// Colors: http://www.material-ui.com/#/customization/colors
// Themable Items: https://github.com/callemall/material-ui/blob/master/src/styles/getMuiTheme.js

const getMuiTheme = require("material-ui/styles/getMuiTheme").default;

const muiTheme = getMuiTheme({
    fontFamily: "Nunito, sans-serif",
    stepper: {
        iconColor: "#4BA6A0"
    },
    palette: {
        //Default Light Theme Options to Customzie:

        primary1Color: "#4BA6A0",
        // primary2Color: cyan700,
        // primary3Color: grey400,
        accent1Color: "#596e7b",
        // accent2Color: grey100,
        // accent3Color: grey500,
        textColor: "#555555"
        // alternateTextColor: white,
        // canvasColor: white,
        // borderColor: grey300,
        // disabledColor: fade(darkBlack, 0.3),
        // pickerHeaderColor: cyan500,
        // clockCircleColor: fade(darkBlack, 0.07),
        // shadowColor: fullBlack,
    }
});
module.exports = muiTheme;



// WEBPACK FOOTER //
// ./src/styles/themeStyles.js